export const LOCAL_STORAGE = {
  accessToken: 'accessToken',
};
